import { Box } from '@mui/material';

import routes from '@/assets/constants/routes-no.ts';
import { ArrowLink } from '@/competitions/_common/components/ArrowLink.tsx';
import { UnderlinedText } from '@/components/UnderlinedText/index.ts';
import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';
import type { CompetitionWithConfig } from '@/lib/api/requests.ts';
import { Timer, type TimerTheme } from '@/ui/Timer.tsx';

import { JANUARY_OPEN_2025_CAMPAIGN_END_DATE } from '../../../config.ts';
import { CTA } from '../_components/CTA.tsx';
import { Section } from '../_components/Section.tsx';

const dateFormatter = new Intl.DateTimeFormat('no', {
  day: 'numeric',
  month: 'long',
});
const dateStr = dateFormatter.format(JANUARY_OPEN_2025_CAMPAIGN_END_DATE);

const timerTheme: TimerTheme = {
  backgroundColor: '#355383',
  digitsColor: '#FFFFFF',
  labelsColor: '#F0F4FA',
};

export const TimerSection = (props: { activeCompetition: CompetitionWithConfig | undefined }) => {
  return (
    <Section
      sx={{
        gap: '20px',
        flexDirection: { md: 'row' },
        flexWrap: { md: 'wrap', xl: 'initial' },
      }}
    >
      <Box
        sx={{
          textAlign: { xs: 'center', xl: 'left' },
          flex: { xl: 1.15 },
          width: { md: '100%', xl: 'auto' },
          mb: { md: 2 },
          pr: { xl: 8 },
          mt: { xl: 4 },
        }}
      >
        <div className="mb-6 typography-v1-h1">Gjeldfri!</div>

        <p className="mx-auto mb-8 max-w-[70ch] typography-v1-body3">
          Sjekk om du kan få lavere rente og delta i trekningen om å få slettet din rentebærende
          forbruks- og kredittkortgjeld.
          <br />
          <br />
          Ett lån med lavere rente gjør det enklere å bli gjeldfri og det er lettere å betjene.
        </p>

        <CTA
          activeCompetition={props.activeCompetition}
          onClick={() => {
            sendUserPortalEvent('jano25_competition_cta_timer_clicked');
          }}
        />
      </Box>
      <Box
        sx={{
          bgcolor: (theme) => theme.palette.background.default,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '8px',
          flex: { md: 1 },
        }}
      >
        <p className="mb-4 typography-v1-h2">Premie</p>
        <p className="mb-2 typography-v1-h3">Få slettet din rentebærende</p>
        <p className="mb-6 typography-v1-h2">
          <UnderlinedText>forbruks- og kredittkortgjeld</UnderlinedText>
        </p>

        <p className="mt-auto mb-4 typography-v1-body3">
          Vi nedbetaler din eksisterende forbruks- og kredittkortgjeld dersom du vinner. Maks.
          400&nbsp;000&nbsp;kr
        </p>

        <ArrowLink
          to={routes.JANUARY_OPEN_2025_COMPETITION_TERMS}
          sx={{ display: 'block', my: 2, mt: { sm: 3 } }}
        >
          Vilkår og betingelser
        </ArrowLink>
      </Box>
      <Box
        sx={{
          bgcolor: (theme) => theme.palette.background.contrast,
          color: (theme) => theme.palette.common.white,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '8px',
          flex: { md: 1 },
        }}
      >
        <p className="typography-v1-h2">Trekningsdato</p>
        <Box component="p" className="typography-v1-display" sx={{ fontSize: { lg: '3.812rem' } }}>
          {dateStr}
        </Box>
        <Timer date={JANUARY_OPEN_2025_CAMPAIGN_END_DATE} theme={timerTheme} />

        <p className="mt-6 mb-4 typography-v1-body3 md:mt-8 xl:mt-12">
          Vinnerne kontaktes via e-post og mobil.
          <br />
          Vi tar hensyn til personvern og publiserer ikke vinnere uten samtykke.
        </p>

        <ArrowLink
          to={routes.JANUARY_OPEN_2025_COMPETITION_TERMS}
          sx={{ display: 'block', my: 2, mt: { sm: 3 } }}
        >
          Vilkår og betingelser
        </ArrowLink>
      </Box>
    </Section>
  );
};
